import { useNavigate } from "react-router-dom";
import { Camera, ScanLine, Sparkles } from "lucide-react";

const POINTS = [
  "Reads your actual handwriting, not just typed text",
  "Finds the exact step where the mistake happened",
  "Never just gives the corrected answer away",
];

export default function LandingHomeworkPhotoHelp() {
  const navigate = useNavigate();
  return (
    <section id="homework-help" className="py-10 sm:py-16 bg-[#26C4D5]/[0.06] border-b border-[#26C4D5]/10" data-testid="landing-homework-photo-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
        <div className="order-2 md:order-1 relative pb-6" data-testid="homework-photo-visual">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/efb5525d-e484-4894-a0d3-6f8b4f2b6938/images/06ad74f39fb38b5e87ffd04704569cfc2489b38c13e4a6b282e8ff5bc209611d.jpeg"
            alt="Indian student photographing homework notebook for AI review"
            className="rounded-3xl shadow-xl w-full object-cover aspect-[4/5]"
          />
          <div className="absolute -bottom-2 right-3 sm:right-6 bg-card/95 backdrop-blur border border-[#26C4D5]/40 rounded-2xl px-4 py-3 shadow-xl shadow-[#26C4D5]/10 flex items-center gap-2" data-testid="homework-photo-scan-badge">
            <ScanLine size={16} className="text-[#26C4D5]" />
            <span className="text-xs font-bold">AI reading your handwriting...</span>
          </div>
        </div>
        <div className="order-1 md:order-2">
          <p className="text-xs font-bold uppercase tracking-widest text-primary">Homework Photo Review</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2">Stuck on homework? Just snap a photo.</h2>
          <p className="text-muted-foreground mt-3">
            Take a picture of your handwritten notebook page — SmartGuru's Vision AI reads your exact working, spots
            precisely where it went wrong, and asks a guiding question so you fix it yourself, instead of just
            handing you the answer.
          </p>
          <ul className="mt-5 space-y-2.5">
            {POINTS.map((t) => (
              <li key={t} className="flex items-start gap-2 text-sm" data-testid={`homework-photo-point-${POINTS.indexOf(t)}`}>
                <Sparkles size={15} className="text-secondary shrink-0 mt-0.5" /> {t}
              </li>
            ))}
          </ul>
          <button
            onClick={() => navigate("/onboarding")}
            data-testid="homework-photo-cta"
            className="inline-flex items-center gap-2 mt-6 bg-primary text-primary-foreground font-bold px-6 py-3 rounded-full hover:bg-primary/90 active:scale-95 transition-all"
          >
            <Camera size={16} /> Try Homework Help
          </button>
        </div>
      </div>
    </section>
  );
}
